import { render, staticRenderFns } from "./MakeInterestingButton.vue?vue&type=template&id=4498a658&scoped=true&"
import script from "./MakeInterestingButton.vue?vue&type=script&lang=js&"
export * from "./MakeInterestingButton.vue?vue&type=script&lang=js&"
import style0 from "./MakeInterestingButton.vue?vue&type=style&index=0&id=4498a658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498a658",
  null
  
)

export default component.exports